export default "__VITE_ASSET__BvuHMIpK__"